import { useState } from 'react';
import TabSelector from 'modules/common/components/TabSelector';
import ClinicServicesProvidersContainer from './ClinicServicesProvidersContainer';
import ClinicServicesServicesContainer from './ClinicServicesServicesContainer';
import { PageTabs, PageTabsOptions } from './helper';
import { Container, Wrapper } from './style';

const ClinicServicesProvidersAndServicesContainerSelector = () => {
  const [selectedTabOption, setSelectedTabOption] = useState(PageTabs.Providers);
  return (
    <Container>
      <Wrapper>
        <TabSelector
          onChange={payload => {
            setSelectedTabOption(payload.value);
          }}
          options={PageTabsOptions}
          value={selectedTabOption}
        />
        {selectedTabOption === PageTabs.Providers && <ClinicServicesProvidersContainer />}
        {selectedTabOption === PageTabs.Services && <ClinicServicesServicesContainer />}
      </Wrapper>
    </Container>
  );
};

ClinicServicesProvidersAndServicesContainerSelector.propTypes = {};

ClinicServicesProvidersAndServicesContainerSelector.defaultProps = {};

export default ClinicServicesProvidersAndServicesContainerSelector;
